import React, { Component } from "react";
import {
  Button,
  Container,
  Row, Form,
  Col,
  Offcanvas,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from '../config.json';

import LoadingOverlay from "./LoadingOverlay";
export default class Healthcodemasterone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.healthcodemasterone_Id,
          sortable: true,
          cell: (row) => <span>{row.healthcodemasterone_Id}</span>,
        },
        { name: "Insurer name", selector: (row, i) => row.insurername, sortable: true, cell: (row) => <span>{row.insurername}</span>, }, { name: "Product name", selector: (row, i) => row.productname, sortable: true, cell: (row) => <span>{row.productname}</span>, }, { name: "Product code", selector: (row, i) => row.productcode, sortable: true, cell: (row) => <span>{row.productcode}</span>, }, { name: "Product id", selector: (row, i) => row.productid, sortable: true, cell: (row) => <span>{row.productid}</span>, }, { name: "Gender", selector: (row, i) => row.gender, sortable: true, cell: (row) => <span>{row.gender}</span>, }, { name: "Gender Cd", selector: (row, i) => row.genderCd, sortable: true, cell: (row) => <span>{row.genderCd}</span>, }, { name: "Plantype", selector: (row, i) => row.plantype, sortable: true, cell: (row) => <span>{row.plantype}</span>, }, { name: "Plantype Cd", selector: (row, i) => row.plantypeCd, sortable: true, cell: (row) => <span>{row.plantypeCd}</span>, }, { name: "covertype", selector: (row, i) => row.covertype, sortable: true, cell: (row) => <span>{row.covertype}</span>, }, { name: "Covertype Cd", selector: (row, i) => row.covertypeCd, sortable: true, cell: (row) => <span>{row.covertypeCd}</span>, }, { name: "Tenure", selector: (row, i) => row.tenure, sortable: true, cell: (row) => <span>{row.tenure}</span>, }, { name: "Tenure Cd", selector: (row, i) => row.tenureCd, sortable: true, cell: (row) => <span>{row.tenureCd}</span>, }, { name: "Contact Type", selector: (row, i) => row.contacttype, sortable: true, cell: (row) => <span>{row.contacttype}</span>, }, { name: "Contact Type Cd", selector: (row, i) => row.contacttypeCd, sortable: true, cell: (row) => <span>{row.contacttypeCd}</span>, }, { name: "Emailtype", selector: (row, i) => row.emailtype, sortable: true, cell: (row) => <span>{row.emailtype}</span>, }, { name: "Email Type Cd", selector: (row, i) => row.emailtypeCd, sortable: true, cell: (row) => <span>{row.emailtypeCd}</span>, }, { name: "Title", selector: (row, i) => row.title, sortable: true, cell: (row) => <span>{row.title}</span>, }, { name: "Title Cd", selector: (row, i) => row.titleCd, sortable: true, cell: (row) => <span>{row.titleCd}</span>, }, { name: "Dummy one", selector: (row, i) => row.dummyone, sortable: true, cell: (row) => <span>{row.dummyone}</span>, }, { name: "Dummy two", selector: (row, i) => row.dummytwo, sortable: true, cell: (row) => <span>{row.dummytwo}</span>, }, { name: "Dummy three", selector: (row, i) => row.dummythree, sortable: true, cell: (row) => <span>{row.dummythree}</span>, },
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                variant="primary"
                onClick={this.handleOffcanvasShow}
                className="bi bi-pen" style={{ "marginRight": "3px" }}
              >

              </Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              >

              </Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      insurername: '', productname: '', productcode: '', productid: '', gender: '', genderCd: '', plantype: '', plantypeCd: '', covertype: '', covertypeCd: '', tenure: '', tenureCd: '', contacttype: '', contacttypeCd: '', emailtype: '', emailtypeCd: '', title: '', titleCd: '', dummyone: '', dummytwo: '', dummythree: '',
    };
  }
  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({ show: true });
  };
  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({ show: false });
  };
  showToast = (msg, type) => {
    var tType = toast.TYPE.INFO;
    if (type === "success") tType = toast.TYPE.SUCCESS;
    if (type === "error") tType = toast.TYPE.ERROR;
    if (type === "warning") tType = toast.TYPE.WARNING;
    toast(msg, { type: tType });
  };
  HealthcodemasteroneeditHandler = (e) => {
    e.preventDefault();
    // const updateFormData = {...editFormData};
    // updateFormData['Healthcodemasterone_Id'] = e.target.parentElement.getAttribute("id");
    // setEditFormData(updateFormData);
    // setEdit(true);

  }

  HealthcodemasteronefetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + 'C_Healthcodemasterone/list', {  // Enter your IP address here

      method: 'POST',
      //headers :{ 'Content-Type' : 'application/json'},
      mode: 'cors',
      body: formData// body data type must match "Content-Type" header
    }).then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      });
  }
  HealthcodemasteronesubmitHandler = (e) => {
    e.preventDefault();
    //   setButtons(contacts);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append('insurername', this.state.insurername);
    formData.append('productname', this.state.productname);
    formData.append('productcode', this.state.productcode);
    formData.append('productid', this.state.productid);
    formData.append('gender', this.state.gender);
    formData.append('genderCd', this.state.genderCd);
    formData.append('plantype', this.state.plantype);
    formData.append('plantypeCd', this.state.plantypeCd);
    formData.append('covertype', this.state.covertype);
    formData.append('covertypeCd', this.state.covertypeCd);
    formData.append('tenure', this.state.tenure);
    formData.append('tenureCd', this.state.tenureCd);
    formData.append('contacttype', this.state.contacttype);
    formData.append('contacttypeCd', this.state.contacttypeCd);
    formData.append('emailtype', this.state.emailtype);
    formData.append('emailtypeCd', this.state.emailtypeCd);
    formData.append('title', this.state.title);
    formData.append('titleCd', this.state.titleCd);
    formData.append('dummyone', this.state.dummyone);
    formData.append('dummytwo', this.state.dummytwo);
    formData.append('dummythree', this.state.dummythree);

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + 'C_Healthcodemasterone/add', {  // Enter your IP address here

      method: 'POST',
      //headers :{ 'Content-Type' : 'application/json'},
      mode: 'cors',
      body: formData// body data type must match "Content-Type" header
    }).then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.HealthcodemasteronefetchHandler();
          this.handleOffcanvasClose();
          //  this.setState({insurername:'',productname:'',productcode:'',productid:'',gender:'',genderCd:'',plantype:'',plantypeCd:'',covertype:'',covertypeCd:'',tenure:'',tenureCd:'',contacttype:'',contacttypeCd:'',emailtype:'',emailtypeCd:'',title:'',titleCd:'',dummyone:'',dummytwo:'',dummythree:'',});
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  }
  HealthcodemasteroneupdateHandler = (e) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append('insurername', this.state.insurername);
    formData.append('productname', this.state.productname);
    formData.append('productcode', this.state.productcode);
    formData.append('productid', this.state.productid);
    formData.append('gender', this.state.gender);
    formData.append('genderCd', this.state.genderCd);
    formData.append('plantype', this.state.plantype);
    formData.append('plantypeCd', this.state.plantypeCd);
    formData.append('covertype', this.state.covertype);
    formData.append('covertypeCd', this.state.covertypeCd);
    formData.append('tenure', this.state.tenure);
    formData.append('tenureCd', this.state.tenureCd);
    formData.append('contacttype', this.state.contacttype);
    formData.append('contacttypeCd', this.state.contacttypeCd);
    formData.append('emailtype', this.state.emailtype);
    formData.append('emailtypeCd', this.state.emailtypeCd);
    formData.append('title', this.state.title);
    formData.append('titleCd', this.state.titleCd);
    formData.append('dummyone', this.state.dummyone);
    formData.append('dummytwo', this.state.dummytwo);
    formData.append('dummythree', this.state.dummythree);


    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + 'C_Healthcodemasterone/update', {
      method: 'POST',
      mode: 'cors',
      body: formData
    }).then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.HealthcodemasteronefetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  }

  componentDidMount() {
    this.HealthcodemasteronefetchHandler();

  }
  handleinsurernameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ insurername: fieldValue });
  }; handleproductnameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ productname: fieldValue });
  }; handleproductcodeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ productcode: fieldValue });
  }; handleproductidChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ productid: fieldValue });
  }; handlegenderChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ gender: fieldValue });
  }; handlegenderCdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ genderCd: fieldValue });
  }; handleplantypeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ plantype: fieldValue });
  }; handleplantypeCdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ plantypeCd: fieldValue });
  }; handlecovertypeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ covertype: fieldValue });
  }; handlecovertypeCdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ covertypeCd: fieldValue });
  }; handletenureChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ tenure: fieldValue });
  }; handletenureCdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ tenureCd: fieldValue });
  }; handlecontacttypeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ contacttype: fieldValue });
  }; handlecontacttypeCdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ contacttypeCd: fieldValue });
  }; handleemailtypeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ emailtype: fieldValue });
  }; handleemailtypeCdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ emailtypeCd: fieldValue });
  }; handletitleChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ title: fieldValue });
  }; handletitleCdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ titleCd: fieldValue });
  }; handledummyoneChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyone: fieldValue });
  }; handledummytwoChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummytwo: fieldValue });
  }; handledummythreeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummythree: fieldValue });
  };
  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };
  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
    // implement your edit logic here
  };
  handleDelete = (row, index) => {
    var formData = new FormData();
    formData.append('healthcodemasterone_Id', row.healthcodemasterone_Id);
    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + 'C_Healthcodemasterone/delete', {
      method: 'POST',
      mode: 'cors',
      body: formData
    }).then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.HealthcodemasteronefetchHandler();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  render() {
    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="title_left">
            <h2 style={{ textAlign: "start" }}>Health Code Master One</h2>
          </div>
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                                   dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary"
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>
                      <Offcanvas
                        show={this.state.show}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Healthcodemasterone page</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container style={{ "overflowY": "auto", height: "auto" }}>
                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Insurer name</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleinsurernameChange} className="form-control" name="insurername" value={this.state.insurername} required="required" placeholder="Enter insurername" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.insurername} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Product name</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleproductnameChange} className="form-control" name="productname" value={this.state.productname} required="required" placeholder="Enter productname" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.productname} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Product code</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleproductcodeChange} className="form-control" name="productcode" value={this.state.productcode} required="required" placeholder="Enter productcode" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.productcode} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Product id</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleproductidChange} className="form-control" name="productid" value={this.state.productid} required="required" placeholder="Enter productid" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.productid} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Gender</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlegenderChange} className="form-control" name="gender" value={this.state.gender} required="required" placeholder="Enter gender" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.gender} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Gender Cd</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlegenderCdChange} className="form-control" name="genderCd" value={this.state.genderCd} required="required" placeholder="Enter genderCd" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.genderCd} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Plantype</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleplantypeChange} className="form-control" name="plantype" value={this.state.plantype} required="required" placeholder="Enter plantype" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.plantype} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Plantype Cd</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleplantypeCdChange} className="form-control" name="plantypeCd" value={this.state.plantypeCd} required="required" placeholder="Enter plantypeCd" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.plantypeCd} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>covertype</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlecovertypeChange} className="form-control" name="covertype" value={this.state.covertype} required="required" placeholder="Enter covertype" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.covertype} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Covertype Cd</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlecovertypeCdChange} className="form-control" name="covertypeCd" value={this.state.covertypeCd} required="required" placeholder="Enter covertypeCd" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.covertypeCd} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Tenure</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletenureChange} className="form-control" name="tenure" value={this.state.tenure} required="required" placeholder="Enter tenure" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.tenure} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Tenure Cd</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletenureCdChange} className="form-control" name="tenureCd" value={this.state.tenureCd} required="required" placeholder="Enter tenureCd" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.tenureCd} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Contact Type</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlecontacttypeChange} className="form-control" name="contacttype" value={this.state.contacttype} required="required" placeholder="Enter contacttype" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.contacttype} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Contact Type Cd</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlecontacttypeCdChange} className="form-control" name="contacttypeCd" value={this.state.contacttypeCd} required="required" placeholder="Enter contacttypeCd" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.contacttypeCd} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Emailtype</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleemailtypeChange} className="form-control" name="emailtype" value={this.state.emailtype} required="required" placeholder="Enter emailtype" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.emailtype} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Email Type Cd</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleemailtypeCdChange} className="form-control" name="emailtypeCd" value={this.state.emailtypeCd} required="required" placeholder="Enter emailtypeCd" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.emailtypeCd} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Title</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletitleChange} className="form-control" name="title" value={this.state.title} required="required" placeholder="Enter title" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.title} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Title Cd</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletitleCdChange} className="form-control" name="titleCd" value={this.state.titleCd} required="required" placeholder="Enter titleCd" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.titleCd} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Dummy one</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummyoneChange} className="form-control" name="dummyone" value={this.state.dummyone} required="required" placeholder="Enter dummyone" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyone} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Dummy two</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummytwoChange} className="form-control" name="dummytwo" value={this.state.dummytwo} required="required" placeholder="Enter dummytwo" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummytwo} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Dummy three</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummythreeChange} className="form-control" name="dummythree" value={this.state.dummythree} required="required" placeholder="Enter dummythree" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummythree} </div>
                                  </Row><br />
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.HealthcodemasteronesubmitHandler}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ "marginRight": "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        paginationRowsPerPageOptions={[10, 20, 30, 50, 60, 70, 80, 90, 100]}
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}
